import { render, staticRenderFns } from "./bankStatement.vue?vue&type=template&id=4d16a7d0&scoped=true"
import script from "./bankStatement.vue?vue&type=script&lang=js"
export * from "./bankStatement.vue?vue&type=script&lang=js"
import style0 from "./bankStatement.vue?vue&type=style&index=0&id=4d16a7d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d16a7d0",
  null
  
)

export default component.exports